import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 13H3V5h18v11z"
}), 'VideoLabelSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideoLabelSharp.js
// module id = 7043
// module chunks = 2